import { QueryKeys } from "@/constants/Query";
import { useApiMutation } from "@/hooks/useApiMutation";
import axiosInstance from "@/lib/axios";
import type { DiagnosticReport } from "@curai/js-fhir-tools";
import { useQueryClient } from "@tanstack/react-query";

export type ManualResult = {
  code: string;
  resultValue: string;
  codeDisplay: string;
};

interface SubmitManualResultsParams {
  results: ManualResult[];
}

interface SubmitManualResultsResponse {
  diagnosticReport: DiagnosticReport;
}

export const useSubmitManualResults = ({
  patientId,
  diagnosticReportId,
  serviceRequestId,
  onSuccess,
}: {
  patientId: string;
  diagnosticReportId: string;
  serviceRequestId: string;
  onSuccess?: () => void;
}) => {
  const queryClient = useQueryClient();

  return useApiMutation<SubmitManualResultsResponse, SubmitManualResultsParams>(
    {
      mutationOptions: {
        mutationKey:
          QueryKeys.Patient.MedicalRecords.Labs.SUBMIT_MANUAL_RESULTS(
            patientId,
            serviceRequestId,
          ),
        mutationFn: (params: SubmitManualResultsParams) => {
          return axiosInstance.post(
            `/labs/results/${diagnosticReportId}/manual-results`,
            {
              serviceRequestId,
              results: params.results,
            },
          );
        },
        onSuccess: () => {
          queryClient.invalidateQueries({
            queryKey: QueryKeys.Patient.MedicalRecords.Labs.DEFAULT(patientId),
          });
          onSuccess?.();
        },
      },
    },
  );
};
